<template>
  <div
    class="modal modal-bottom fade"
    id="qrcode-modal-member"
    tabindex="-1"
    role="dialog"
    aria-labelledby="qrcode-modal-member"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <!-- MBR theme 2 — member_app_UI/song_fa_members_my_member_qr -->
      <div class="modal-content mbr-qr">
        <div class="mbr-qr__top">
          <span class="mbr-qr__handle" aria-hidden="true"></span>
          <!-- keep .btn-close: views close every open sheet with $(".btn-close").click() -->
          <button type="button" class="btn-close mbr-qr__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <div class="mbr-qr__body" v-if="isLogined">
          <span v-if="memberInfo.tier_name" class="mbr-qr__tier">{{ memberInfo.tier_name }}</span>
          <h2 class="mbr-qr__name">
            {{
              memberInfo.name || memberInfo.last_name
                ? (memberInfo.name ? memberInfo.name : "") +
                  " " +
                  (memberInfo.last_name
                    ? memberInfo.last_name
                    : "")
                : memberInfo.phone_number
                ? memberInfo.phone_number
                : ""
            }}
          </h2>
          <p class="mbr-qr__id">{{ $t('qr.member_id', { id: memberInfo.member_id_text }) }}</p>
          <div class="mbr-qr__frame">
            <VueQRCodeComponent
              :text="phoneNumber"
              size="208"
              :color="qrColor"
              bg-color="#ffffff"
              error-level="L"
              class="d-flex justify-content-center"
            />
          </div>
          <p class="mbr-qr__caption">{{ $t('qr.caption') }}</p>
          <p class="mbr-qr__tip">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" /></svg>
            <span>{{ $t('qr.brightness_tip') }}</span>
          </p>
        </div>
        <!-- signed-out fallback: the sheet used to render empty when the session had expired -->
        <div class="mbr-qr__body" v-else-if="hasLoaded">
          <span class="mbr-qr__emblem" aria-hidden="true">
            <!-- finders stroked, matrix dots filled: a single stroked path blurs into a blob at 30px -->
            <svg viewBox="0 0 24 24" fill="none">
              <g stroke="currentColor" stroke-width="1.6" stroke-linejoin="round">
                <rect x="3.75" y="3.75" width="6.75" height="6.75" rx="1.5" />
                <rect x="13.5" y="3.75" width="6.75" height="6.75" rx="1.5" />
                <rect x="3.75" y="13.5" width="6.75" height="6.75" rx="1.5" />
              </g>
              <g fill="currentColor">
                <rect x="13.5" y="13.5" width="2.75" height="2.75" rx="0.6" />
                <rect x="17.5" y="13.5" width="2.75" height="2.75" rx="0.6" />
                <rect x="13.5" y="17.5" width="2.75" height="2.75" rx="0.6" />
                <rect x="17.5" y="17.5" width="2.75" height="2.75" rx="0.6" />
              </g>
            </svg>
          </span>
          <h2 class="mbr-qr__name mbr-qr__name--signedout">{{ $t('qr.signed_out_title') }}</h2>
          <p class="mbr-qr__signedout-text">
            {{ $t('qr.signed_out_text') }}
          </p>
          <button type="button" class="mbr-qr__cta" data-bs-dismiss="modal" @click="goSignIn">
            {{ $t('qr.sign_in') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";
import moment from "moment";
import MemberService from '../services/member.service';
import EventBus from "vue3-eventbus";
import { localStorageName, getMerchantCode } from "@/config/utils";
import { themeTokenValue } from "@/config/themeColor";

export default {
  name: "QrcodeReward",
  components: {
    VueQRCodeComponent,
  },
  data() {
    return {
      isLogined: false,
      // false until get-member-info settles, so the signed-out state never flashes
      hasLoaded: false,
      merchantLogo: localStorage.getItem(localStorageName('MERCHANT_LOGO'), ''),
      memberInfo: null,
      phoneNumber: '',
      qrColor: themeTokenValue("--mbr-color-qr", "#3A0F0F"),
    };
  },
  created() {
    this.getMemberInfo();
  },
  mounted() {
    EventBus.on("reloadMembershipCard", () => {
      this.getMemberInfo();
    });
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/Y");
    },
    goSignIn() {
      const code = getMerchantCode();
      this.$router.push((code ? `/${code}` : "") + "/sign-in");
    },
    getMemberInfo() {
      MemberService.getMemberInfo().then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.memberInfo = response.data.data;
              this.phoneNumber = this.memberInfo.phone_number ?? '';
              this.isLogined = true;
            }
            this.hasLoaded = true;
          },
          (error) => {
            console.log("error", error);
            this.hasLoaded = true;
          }
      );
    },
  }
};
</script>
<style scoped>
/* MBR theme 2 member QR sheet. Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-qr {
  padding: 12px 24px 32px;
  background: var(--mbr-color-surface);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
  /* .modal.modal-bottom .modal-content below already sets overflow-y: auto */
  max-height: 92vh;
}

.mbr-qr__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-qr__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

/* reset Bootstrap's .btn-close (svg background, 1em box, 50% opacity) */
.mbr-qr__close.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint) none;
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  opacity: 1;
  transition: transform 0.12s ease;
}

.mbr-qr__close.btn-close:active {
  transform: scale(0.95);
}

.mbr-qr__close.btn-close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
  box-shadow: none;
}

.mbr-qr__close svg {
  width: 16px;
  height: 16px;
}

.mbr-qr__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.mbr-qr__tier {
  padding: 4px 12px;
  background: var(--mbr-color-peach);
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-primary);
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-qr__name {
  margin: 10px 0 0;
  font-family: var(--mbr-font-headline);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: var(--mbr-color-ink-headline);
}

.mbr-qr__id {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--mbr-color-ink-muted);
}

.mbr-qr__caption {
  margin: 12px 0 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-qr__tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 16px 0 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 15px;
  color: var(--mbr-color-ink-muted);
}

.mbr-qr__tip svg {
  flex: none;
  width: 14px;
  height: 14px;
}

/* signed-out state */
.mbr-qr__emblem {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-qr__emblem svg {
  width: 30px;
  height: 30px;
}

.mbr-qr__name--signedout {
  font-size: var(--mbr-headline-sm-size);
  font-weight: var(--mbr-headline-sm-weight);
  line-height: var(--mbr-headline-sm-line);
  letter-spacing: var(--mbr-headline-sm-tracking);
}

.mbr-qr__signedout-text {
  max-width: 280px;
  margin: 8px 0 0;
  font-size: var(--mbr-body-sm-size);
  font-weight: var(--mbr-body-sm-weight);
  line-height: var(--mbr-body-sm-line);
  color: var(--mbr-color-ink-muted);
}

.mbr-qr__cta {
  width: 100%;
  margin-top: 20px;
  padding: 14px 24px;
  background: var(--mbr-color-primary);
  border: 0;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-label-md-size);
  font-weight: 700;
  line-height: var(--mbr-label-md-line);
  color: var(--mbr-color-on-primary);
  transition: transform 0.12s ease;
}

.mbr-qr__cta:active {
  transform: scale(0.98);
}

.mbr-qr__frame {
  margin-top: 16px;
  padding: 16px;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-card);
}

/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--mbr-color-surface);
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}
</style>
